import React from 'react'
import {BrowserRouter as Router, Routes, Route} from  'react-router-dom'
import Header from './components/ui/Header'
import Home from './pages/Home'
import InventoryItems from './pages/InventoryItems'
import ItemGroups from './pages/ItemGroups'
import Login from './components/LoginWithOtp';
import Register from './components/Register';
// import About from './pages/About'
// import Contact from './pages/Contact'
import './css/globals.css'
import Layout from './components/ui/Layout'

import NotFound from './utils/NotFound';
import { AuthProvider } from './utils/AuthContext';
import { PublicRoute } from './utils/PublicRoute';
import Dashboard from './pages/Dashboard'
import ItemSearch from './components/sections/ItemSearch'
import UserProfile from './pages/UserProfile'
import RGPList from './components/rgp/RGPList'
import ProcessPage from './components/process-sheet/ProcessPage'
import ProcessSheet from './components/process-sheet/ProcessSheetApp'
import ProcessSheetPage from './components/ProcessSheet/index'

function MainRoutes() {

    const videos = [
        { id: 1, title: 'Getting Started with React', thumbnail: 'https://placehold.co/360x200', channel: 'React Channel', views: '120K', posted: '1 week ago' },
        { id: 2, title: 'MERN Stack Tutorial', thumbnail: 'https://placehold.co/360x200', channel: 'Web Dev Simplified', views: '85K', posted: '3 days ago' },
        { id: 3, title: 'Tailwind CSS Crash Course', thumbnail: 'https://placehold.co/360x200', channel: 'CSS Wizards', views: '220K', posted: '2 weeks ago' },
        { id: 4, title: 'Building a YouTube Clone', thumbnail: 'https://placehold.co/360x200', channel: 'Coding Masters', views: '45K', posted: '5 days ago' },
        { id: 5, title: 'JavaScript ES6 Features', thumbnail: 'https://placehold.co/360x200', channel: 'JS Pro', views: '130K', posted: '1 month ago' },
        { id: 6, title: 'Responsive Web Design Tips', thumbnail: 'https://placehold.co/360x200', channel: 'Design Hub', views: '75K', posted: '2 days ago' },
        { id: 7, title: 'MongoDB for Beginners', thumbnail: 'https://placehold.co/360x200', channel: 'Database Masters', views: '60K', posted: '3 weeks ago' },
        { id: 8, title: 'Express.js Tutorial', thumbnail: 'https://placehold.co/360x200', channel: 'Node Experts', views: '95K', posted: '4 days ago' },
    ];

    const userRole = localStorage.getItem('userRole');

    return (
    <Router>
        <AuthProvider>

            {localStorage.getItem('token') ? (

            <Layout>
                {/* <h1 className="text-xl font-bold mb-4">Recommended</h1> */}
                {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {videos.map(video => (
                    <div key={video.id} className="bg-white dark:bg-gray-800 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                    <div className="aspect-video bg-gray-300 dark:bg-gray-700">
                        <img 
                        src="/api/placeholder/360/200" 
                        alt={video.title}
                        className="w-full h-full object-cover"
                        />
                    </div>
                    <div className="p-3">
                        <h3 className="font-medium text-sm line-clamp-2">{video.title}</h3>
                        <p className="text-gray-600 dark:text-gray-400 text-xs mt-1">{video.channel}</p>
                        <p className="text-gray-600 dark:text-gray-400 text-xs mt-1">
                        {video.views} views • {video.posted}
                        </p>
                    </div>
                    </div>
                ))}
                </div> */}

                <Routes>
                    <Route index element={<PublicRoute><Home /></PublicRoute>} />
                    {/* <Route index element={<Home />} /> */}
                    {/* <Route path='/about' element={<About />} />
                    <Route path='/contact' element={<Contact />} /> */}
                    <Route path='*' element={<NotFound />} />

                    <Route path='/dashboard' element={<Dashboard />} />
                    <Route path='/profile' element={<UserProfile />} />
                    {["super_admin", "admin_user", "item_user"].includes(userRole) && (
                        <>
                    <Route path='/inventory' element={<InventoryItems />} />
                    <Route path='/itemgroups' element={<ItemGroups />} />
                    <Route path='/rgp' element={<RGPList />} />
                        </>
                    )}
                    <Route path='/itemsearch' element={<ItemSearch />} />
                    {["super_admin", "admin_user", "process_user"].includes(userRole) && (
                        <>
                        <Route path='/process-sheet-old' element={<ProcessSheet />} />
                        <Route path='/process-sheet' element={<ProcessSheetPage />} />
                        </>
                    )}
                </Routes>

            </Layout>
            ) : (
                <Routes>
                    <Route index element={<PublicRoute><Login /></PublicRoute>} />
                    <Route path='*' element={<NotFound />} />
    
                    <Route path="register" element={<PublicRoute><Register /></PublicRoute>} />
                    <Route path="login" element={<PublicRoute><Login /></PublicRoute>} />
                </Routes>
            )}

        </AuthProvider>

    </Router>
    )
}

export default MainRoutes